import { FormEvent, useEffect, useState, FC } from "react";

import { useNavigate } from "react-router";

import { UserBody } from "@vviinn/user-managment-client-ts";

import { useRequestHandlers } from "../../app/hooks/useRequestHandlers";
import { useAppSelector } from "../../store";

import { PasswordInput } from "../../components/Interaction/PasswordInput";

import { DetailedWrapper } from "../../ui/layout/general/DetailedWrapper/DetailedWrapper";
import { INPUT_FIELD_STYLES } from "../../ui/layout/detailedPages/styles";
import { generatePassword } from "../../user/helpers";
import { handleUser } from "../../user/handleUser";
import { FormRow, SubSectionWithStyles } from "../../ui/layout";

export const UserNew: FC<React.PropsWithChildren> = () => {
  const [name, setName] = useState("");
  const [password, setPassword] = useState(generatePassword());
  const [email, setEmail] = useState("");
  const navigate = useNavigate();
  const handlerParams = useRequestHandlers();
  const { handleCreateUser } = handleUser(handlerParams);

  const backLink = "/users";
  const navigateBack = () => navigate(backLink);
  const permissions = useAppSelector(
    (state) => state.company?.company?.featurePermissions,
  );
  const userPermissions = permissions
    ? permissions.find((p) => p.name === "user")
    : undefined;

  const createUser = async (e: FormEvent) => {
    const user: UserBody = {
      displayName: name,
      email,
      password,
    };
    const newUserId = await handleCreateUser(user);
    if (newUserId) {
      return `/users/show/${newUserId}`;
    }
  };

  useEffect(() => {
    if (!userPermissions) navigateBack();
    const userCreatePermissions =
      userPermissions?.features["user"].includes("create");
    if (!userCreatePermissions) navigateBack();
  }, [navigateBack, userPermissions]);

  return (
    <DetailedWrapper
      createItemAction={createUser}
      backLink={backLink}
      detailedPageType="new"
      detailedPage="user"
    >
      <SubSectionWithStyles title="General Information" isSubHeader={false}>
        <FormRow labelText="Username" labelHtmlFor="username">
          <input
            type="text"
            name="username"
            id="username"
            autoComplete="given-name"
            required
            className={INPUT_FIELD_STYLES}
            onChange={(ev) => setName(ev.target.value)}
          />
        </FormRow>
        <FormRow labelText="Email" labelHtmlFor="user-email">
          <input
            type="email"
            name="user-email"
            id="user-email"
            autoComplete="email"
            required
            className={INPUT_FIELD_STYLES}
            onChange={(ev) => setEmail(ev.target.value)}
          />
        </FormRow>
        <FormRow labelText="Password" labelHtmlFor="password">
          <PasswordInput
            onChange={(ev) => setPassword(ev.target.value)}
            value={password}
            required
          />
        </FormRow>
      </SubSectionWithStyles>
    </DetailedWrapper>
  );
};
